var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6067_89428)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87568 10.5251C5.78207 10.6275 5.64841 10.6914 5.49978 10.6914C5.36805 10.6914 5.23632 10.6402 5.13547 10.5374L2.5626 7.91465C2.36138 7.70953 2.36138 7.3775 2.5626 7.17238C2.76333 6.96775 3.08904 6.96775 3.29026 7.17238L4.98545 8.90046L4.98545 3.87123C4.98545 3.5815 5.21563 3.34637 5.49984 3.34637C5.78406 3.34637 6.01471 3.5815 6.01471 3.87123L6.01471 8.89945L7.70892 7.17238C7.90965 6.96775 8.23584 6.96775 8.43658 7.17238C8.6378 7.3775 8.6378 7.70953 8.43658 7.91465L5.87568 10.5251ZM10.1316 4.39457C9.84742 4.39457 9.61677 4.15944 9.61677 3.86971L9.61677 1.77128C9.61677 1.63207 9.56272 1.49876 9.46621 1.40039C9.3697 1.30202 9.23894 1.24691 9.10238 1.24691L1.89765 1.24691C1.76109 1.24691 1.62984 1.302 1.53382 1.40039C1.43731 1.49877 1.38278 1.63207 1.38278 1.77128L1.38278 3.86971C1.38278 4.15944 1.15261 4.39457 0.868391 4.39457C0.583692 4.39457 0.35352 4.15944 0.35352 3.86971L0.35352 1.77128C0.35352 1.35366 0.516133 0.953743 0.805662 0.658119C1.09519 0.362974 1.48796 0.197207 1.89764 0.197207L9.10237 0.197207C9.51204 0.197207 9.90435 0.362975 10.1939 0.65812C10.4839 0.953756 10.6465 1.35366 10.6465 1.77128L10.6465 3.86971C10.6465 4.15944 10.4159 4.39457 10.1316 4.39457Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6067_89428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(11 11) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlack);
export default __webpack_public_path__ + "static/media/download_black.969f42e7cd0b8a2f77022bb2f5c0f690.svg";
export { ForwardRef as ReactComponent };